// Memorial entry for Meny Godard
import menyGodardPortrait from '../../../images/meny-godard.jpg';

export const menyGodardMemorial = {
  id: 29,
  name: 'Meny Godard',
  images: {
    portrait: menyGodardPortrait
  },
  info: `
"My father was someone you could call any time, day or night. Unconditional love. Something rare." - His son Goni

# Meny Godard

![Meny Godard](${menyGodardPortrait})
*Meny (Menachem) Godard, 73, a man of the sea and of love*

## A Life at Be'eri

Meny Godard was born in Tel Aviv, the fourth child of Yaakov and Soni. He grew up on the beach alongside his father, who worked as a lifeguard. At age 13, he followed his sister Shmuelah to Kibbutz Be'eri and fell in love with the community. He would remain there for the next 60 years.

At Be'eri, Meny wore many hats - chief economist, printer at the kibbutz printing house, department store manager, and most beloved of all, pool manager and lifeguard, where his father's legacy lived on. It was at the pool that he met Ayelet, who would become his wife of over 40 years.

Together they raised four children - Mor, Gal, Bar, and Goni (adopted in 2005) - and had seven grandchildren.

## Man of the Sea, Heart of Gold

Meny served in the IDF Armored Corps reconnaissance battalion and fought in the Yom Kippur War. But his true passions were gentler: soccer, the ocean, and people.

In his youth, he was a professional soccer player - a striker for Hapoel Be'eri and the team's leading scorer. Later he coached the youth squad. He remained a devoted Hapoel Tel Aviv fan all his life.

His children described him as "a generous man, endlessly kind" with "a special heart of gold." He was "always the first in every kindergarten classroom" for his grandchildren's events - "the most devoted and loving father and grandfather."

## October 7, 2023

On that morning, Meny and his wife Ayelet hid in the safe room of their Be'eri home. Palestinian Islamic Jihad terrorists set fire to the house. Forced to flee the burning structure, they were ambushed by terrorists waiting outside.

Meny was shot and killed. His body was taken to Gaza.

Ayelet made one final phone call to her children, screaming that Meny had been killed. She then hid in nearby bushes for hours before she too was found and murdered.

## 769 Days

Meny's death was confirmed on December 8, 2023, but his body remained in Gaza. For 769 days, his family waited.

On November 13, 2025, Meny finally came home. A military rabbi led a small ceremony at the transfer point as soldiers formed an honor guard.

His family released a statement: "Our father is home. Not the home we hoped for, but the soil of the Land of Israel that he loved so much. He is no longer lying in the cursed streets of Gaza. After 769 days, we can breathe."

## Laid to Rest

Hundreds attended his funeral at Kibbutz Be'eri on November 17, 2025. President Herzog spoke: "When we look around at the gravestones... we can see that on October 7, Hamas terrorists murdered the best of humanity."

His daughter Mor said: "Waiting for that knock at the door was unbearable. Now we can begin to recover."

Meny and Ayelet - the lifeguard and the teacher, the man of the sea and the woman who brought nature into the classroom - are reunited now in the soil of the kibbutz they loved.

*People who spread light in every direction. May their memory be a blessing.*

[Read more about Meny Godard](https://www.timesofisrael.com/the-best-of-humanity-hundreds-attend-funeral-for-slain-hostage-meny-godard/)
`
};
